export const AUTH_TOKEN_KEY = 'oic-authenticationToken';
export const AUTH_REFRESH_TOKEN_KEY = 'oic-authenticationRefreshToken';
export const REDUCER_NAME = 'authentication';
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
